<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.0/css/bootstrap.min.css">
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script> 
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.0/js/bootstrap.min.js"></script>
<div class="main-div" aria-hidden="true">
</div>
<div class="overlay" *ngIf="loading()"
     role="status" aria-live="polite" aria-busy="true">
	<div class="center">
	    <mat-spinner class="custom-spinner"
	                 aria-hidden="true"></mat-spinner>	
	</div>
</div>
<div style="display:flex;justify-content:center;align-items:center"
     [attr.inert]="loading() ? '' : null">
	<mat-card style="text-align: -webkit-center;margin: 10em auto;"> 
        <mat-card-header>
            <mat-card-title>User Verification</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            Please enter the verification code sent to your email address or phone.
        </mat-card-content>
        <mat-card-content>
        <form [formGroup]="verifyForm" (ngSubmit)="onSubmit()">
            <div class="verifyCode"
                 formArrayName="verifyCode"
                 role="group"
                 aria-label="Verification code">
                <div class="verifyCode">
                    <mat-form-field class="codeField" 
                                    appearance="outline" 
                                    *ngFor="let control of verifyCodeControls; let i = index">
                        <input #otpInput
                               matInput 
                               maxlength="1" 
                               class="code"
                               type="text"
                               inputmode="numeric"
                               autocomplete="one-time-code"
                               [attr.aria-label]=
                                   "'Digit ' + (i + 1) +
                                    ' of verification code'"
                               [formControlName]="i" 
                               (input)="handleInput($event, i)"
                               (paste)="handlePaste($event)"
                               required>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <button mat-raised-button
                type="button"
                color="primary"
                (click)="resetCode()">
            Reset Code
        </button>
        <div *ngIf="error() !== ''" class="error-message"
             role="alert">
            {{ error() }}
        </div>
        </mat-card-content>       
	 </mat-card>
</div>	       
